import React, {Component} from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import './ClickToPlay.css'

// 知乎视频播放页的两个域名指向同一播放器（v.vzuu.com 与 video.zhihu.com 等价），
// 统一附加静音自动起播参数，与列表页 / 首页快乐榜保持一致
const VIDEO_PAGE_HOSTS = ['v.vzuu.com/video/', 'video.zhihu.com/video/']

// 生成播放地址：播放页统一带 autoplay + muted，其它源保持原有 ?vzuu=true 行为
const genPlaySrc = src => {
  if (VIDEO_PAGE_HOSTS.some(host => src.indexOf(host) !== -1)) {
    const player = JSON.stringify({autoplay: true, muted: true})
    return `${src}?vzuu=true&player=${encodeURIComponent(player)}`
  }
  return `${src}?vzuu=true`
}

// 媒体区占位 ↔ iframe 切换：默认不创建 iframe，点击播放后才渲染
export default class ClickToPlay extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    title: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.node,
  }

  state = {
    playing: false,
  }

  handlePlay = () => {
    this.setState({playing: true})
  }

  render() {
    const {src, width, height, title, className, placeholder} = this.props
    const {playing} = this.state
    const size = {width, height}

    if (playing) {
      return (
        <iframe
          className={className}
          frameBorder="0"
          width={width}
          height={height}
          style={size}
          src={genPlaySrc(src)}
          allowFullScreen
          title={title}
        />
      )
    }

    return (
      <button
        type="button"
        className={cx('ClickToPlay', className)}
        style={size}
        aria-label={`播放视频：${title}`}
        onClick={this.handlePlay}
      >
        {placeholder && (
          <span className="ClickToPlay-cover">{placeholder}</span>
        )}
        <span className="ClickToPlay-play" aria-hidden="true" />
      </button>
    )
  }
}
